import { Table } from "@procore/core-react";
import { Link } from "react-router-dom";
import type { ReactNode } from 'react';

interface IProcoreLinkCellProps {
  to: string;
  cta: string;
}

export const ProcoreLinkCell = ({ to, cta }: IProcoreLinkCellProps) => {
    return (
        <Table.BodyCell>
            <Table.TextCell>
                <Link to={to}>{cta}</Link>
            </Table.TextCell>
        </Table.BodyCell>
    )
};

interface IProcoreLinkErpCellProps {
  to: string;
  cta: string;
  synced_to_erp?: boolean;
  inactive?: boolean;
  inactiveIcon?: ReactNode;
}

export const ProcoreLinkErpCell = ({ to, cta, synced_to_erp, inactive, inactiveIcon }: IProcoreLinkErpCellProps) => {
    return (
        <Table.BodyCell>
            <Table.TextCell>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Link to={to}>{cta}</Link>
                    {inactive && inactiveIcon}
                    {synced_to_erp && (
                        <img 
                            src="/icon-erp-synced.png" 
                            alt="ERP Synced" 
                            title="This vendor is synced with ERP"
                            style={{ height: '1.25em', flexShrink: 0 }}
                        />
                    )}
                </div>
            </Table.TextCell>
        </Table.BodyCell>
    )
};

export const ProcoreTextCell = ({ text }: { text: string }) => {
    return (
        <Table.BodyCell>
            <Table.TextCell>
                {text}
            </Table.TextCell>
        </Table.BodyCell>
    )
};

export const ProcoreGenericCell = ({ children }: { children: React.ReactNode }) => {
    return (
        <Table.BodyCell>
            <Table.TextCell>
                {children}
            </Table.TextCell>
        </Table.BodyCell>
    )
};

export const ProcoreCurrencyCell = ({ amount }: { amount: string }) => {
    return (
        <Table.BodyCell>
            <Table.CurrencyCell>
                {amount}
            </Table.CurrencyCell>
        </Table.BodyCell>
    )
};

export const ProcorePercentCell = ({ amount }: { amount: string }) => {
    return (
        <Table.BodyCell>
            <Table.PercentCell>
                {amount}
            </Table.PercentCell>
        </Table.BodyCell>
    )
};

export const ProcoreEmptyCell = () => {
    return (
        <Table.BodyCell>
        </Table.BodyCell>
    )
};
